import React from 'react';
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined';
import PostAddIcon from '@material-ui/icons/PostAdd';
import ViewListIcon from '@material-ui/icons/ViewListOutlined';

import ListAltIcon from '@material-ui/icons/ListAlt';
import AssessmentOutlinedIcon from '@material-ui/icons/AssessmentOutlined';
import SettingsIcon from '@material-ui/icons/Settings';
import LabelIcon from '@material-ui/icons/Label';

/**
 * Router Constant
 * Consist of
 * - Path Master (string)
 * - routers (object)
 * - listRoutFrontOf, listRoutBackOf (array getted from routers converting)
 */

// Path Master Front-Office
export const PATH_FRONTOF_MASTER = '/helpdesk';

// Path Master Back-Office
export const PATH_BACKOF_MASTER = '/management';

// Routers
export const routers = {
  frontOf: {
    main: {
      path: `${PATH_FRONTOF_MASTER}/main`,
      title: 'หน้าหลัก',
      icon: HomeOutlinedIcon,
      isMenu: true,
      permissionLevel: [0],
    },
    reportIssue: {
      path: `${PATH_FRONTOF_MASTER}/report-issue`,
      title: 'แจ้งเหตุละเมิด',
      icon: PostAddIcon,
      isMenu: true,
      permissionLevel: [0],
    },
    issues: {
      path: `${PATH_FRONTOF_MASTER}/issues`,
      title: 'รายการเหตุละเมิด',
      icon: ViewListIcon,
      isMenu: true,
      permissionLevel: [0],
    },
    issue: {
      path: `${PATH_FRONTOF_MASTER}/issues/:id/:sid`,
      pathNoParam: `${PATH_FRONTOF_MASTER}/issues`,
      title: 'กิจกรรม',
      icon: ViewListIcon,
      isMenu: false,
      permissionLevel: [0],
    },
  },
  backOf: {
    main: {
      path: PATH_BACKOF_MASTER,
      title: 'จัดการเหตุละเมิดฯ',
      icon: ListAltIcon,
      isMenu: true,
      permissionLevel: [1, 2, 3],
    },
    issue: {
      path: `${PATH_BACKOF_MASTER}/issues/:id/:sid`,
      pathNoParam: `${PATH_BACKOF_MASTER}/issues`,
      title: 'แก้ไขปัญหา',
      isMenu: false,
      permissionLevel: [1, 2, 3],
    },
    report: {
      path: `${PATH_BACKOF_MASTER}/report`,
      title: 'รายงาน',
      icon: AssessmentOutlinedIcon,
      isMenu: true,
      permissionLevel: [1, 2, 3],
    },
    settingPermission: {
      path: `${PATH_BACKOF_MASTER}/setting/permission`,
      title: 'ตั้งค่าสิทธิ์ผู้ใช้งาน',
      icon: SettingsIcon,
      isMenu: true,
      permissionLevel: [8, 9],
    },
    settingLabel: {
      path: `${PATH_BACKOF_MASTER}/setting/label`,
      title: 'ตั้งค่าป้ายกำกับ',
      icon: LabelIcon,
      isMenu: true,
      permissionLevel: [9],
    },
  },
};

// Let breadcrumbs mapping match.path with path (in listRoutFrontOf, listRoutBackOf) for filter title page
export const listRoutFrontOf = Object.keys(routers.frontOf).map((k) => ({
  key: `frontOf-${k}`,
  ...routers.frontOf[k],
}));
export const listRoutBackOf = Object.keys(routers.backOf).map((k) => ({
  key: `backOf-${k}`,
  ...routers.backOf[k],
}));

export const listMenuFrontOf = listRoutFrontOf.filter((item) => item.isMenu);

export const listMenuBackOf = listRoutBackOf.filter((item) => item.isMenu);

// Find unique permissionLevel of backOf - frontOf
const backOfPermissionLevels = listRoutBackOf.map(
  (rout) => rout.permissionLevel
);
const forntOfPermissionLevels = listRoutFrontOf.map(
  (rout) => rout.permissionLevel
);

// https://stackoverflow.com/questions/1960473/get-all-unique-values-in-a-javascript-array-remove-duplicates
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/concat
function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}

export const listPermissionLevelBackOf = []
  .concat(...backOfPermissionLevels)
  .filter(onlyUnique);

export const listPermissionLevelFrontOf = []
  .concat(...forntOfPermissionLevels)
  .filter(onlyUnique);
